// Направление постоянно для локали и не зависит от порядка выбранных вкладок.
export function animateLaptopScreens(outgoing, incoming, delay = 0) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return [];
    }

    const direction = getComputedStyle(incoming).direction === 'rtl' ? -1 : 1;
    const options = { duration: 700, delay, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both' };
    return [
        outgoing.animate([
            { transform: 'translateX(0)', opacity: 1 },
            { transform: `translateX(${direction * 100}%)`, opacity: 1 },
        ], options),
        incoming.animate([
            { transform: `translateX(${-direction * 100}%)`, opacity: 1 },
            { transform: 'translateX(0)', opacity: 1 },
        ], options),
    ];
}
